import { render, staticRenderFns } from "./xinzangwuyou-read.vue?vue&type=template&id=549466e1&scoped=true&"
import script from "./xinzangwuyou-read.vue?vue&type=script&lang=ts&"
export * from "./xinzangwuyou-read.vue?vue&type=script&lang=ts&"
import style0 from "./xinzangwuyou-read.vue?vue&type=style&index=0&id=549466e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549466e1",
  null
  
)

export default component.exports